export const SKILLS_INVENTORY = [
  "Linux & Networking", "Docker & Containers", "Kubernetes",
  "CI/CD Pipelines", "Infrastructure as Code", "Cloud Platforms (AWS/GCP/Azure)",
  "Monitoring & Observability", "Security & Compliance", "Scripting (Bash/Python)",
  "Incident Management", "Architecture & Design", "Technical Communication",
];

export const SKILL_LEVELS = ["Learning", "Competent", "Expert"];
